import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiClient } from "../../lib/api-client";

interface Category {
  id: string;
  name: string;
  slug: string;
}

export function CategoriesPage() {
  const [categories, setCategories] = useState<Category[]>([]);

  useEffect(() => {
    apiClient.get<{ items: Category[] }>("/public/categories").then((data) => setCategories(data.items));
  }, []);

  return (
    <div>
      <h1>Categorias</h1>
      <div className="chip-grid">
        {categories.map((category) => (
          <Link key={category.id} to={`/catalogo?categoria=${category.slug}`} className="chip">
            {category.name}
          </Link>
        ))}
      </div>
    </div>
  );
}
